/**
 * [Gurumi 입력 모달]
 * 역할: yesmoney EditorInputModal 포팅 — 확인 후 닫기/삽입 실패 시 유지
 * 작성/수정일: 2026-07-29
 */
import { iconSvg } from '../icons.js';

export function openInputModal({
  title,
  description,
  label,
  placeholder,
  confirmLabel = '확인',
  initialValue = '',
  inputType = 'url',
  onConfirm,
  onClose,
}) {
  const overlay = document.createElement('div');
  overlay.className = 'g5-gurumi-modal-root';

  const backdrop = document.createElement('button');
  backdrop.type = 'button';
  backdrop.className = 'g5-gurumi-modal-backdrop';
  backdrop.setAttribute('aria-label', '닫기');

  const dialog = document.createElement('div');
  dialog.className = 'g5-gurumi-modal-dialog';
  dialog.setAttribute('role', 'dialog');
  dialog.setAttribute('aria-modal', 'true');

  const head = document.createElement('div');
  head.className = 'g5-gurumi-modal-head';
  head.innerHTML = `<div><h2 class="g5-gurumi-modal-title">${title}</h2>${description ? `<p class="g5-gurumi-modal-desc">${description}</p>` : ''}</div>`;
  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = 'g5-gurumi-modal-close';
  closeBtn.setAttribute('aria-label', '닫기');
  closeBtn.appendChild(iconSvg('x'));
  head.appendChild(closeBtn);

  const body = document.createElement('div');
  body.className = 'g5-gurumi-modal-body';
  const fieldLabel = document.createElement('label');
  fieldLabel.className = 'g5-gurumi-modal-field';
  fieldLabel.innerHTML = `<span>${label}</span>`;
  const input = document.createElement('input');
  // [Gurumi 입력 모달] type=url 은 브라우저 유효성 검사로 확인 클릭이 무력화될 수 있어 text 사용
  // 작성/수정일: 2026-07-29
  input.type = 'text';
  input.inputMode = inputType === 'url' ? 'url' : 'text';
  input.autocomplete = 'off';
  input.spellcheck = false;
  input.placeholder = placeholder || '';
  input.value = initialValue;
  fieldLabel.appendChild(input);
  body.appendChild(fieldLabel);

  const actions = document.createElement('div');
  actions.className = 'g5-gurumi-modal-actions';
  const cancel = document.createElement('button');
  cancel.type = 'button';
  cancel.className = 'g5-gurumi-btn g5-gurumi-btn-secondary';
  cancel.textContent = '취소';
  const ok = document.createElement('button');
  ok.type = 'button';
  ok.className = 'g5-gurumi-btn g5-gurumi-btn-primary';
  ok.textContent = confirmLabel;
  actions.appendChild(cancel);
  actions.appendChild(ok);
  body.appendChild(actions);

  dialog.appendChild(head);
  dialog.appendChild(body);
  overlay.appendChild(backdrop);
  overlay.appendChild(dialog);
  document.body.appendChild(overlay);
  document.body.style.overflow = 'hidden';

  let closed = false;
  function close() {
    if (closed) return;
    closed = true;
    document.body.style.overflow = '';
    overlay.remove();
    onClose?.();
  }

  function submit(event) {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    const value = input.value.trim();
    if (inputType === 'url' && !value) return;
    try {
      // false 반환 시 모달 유지 (검증 실패 등)
      if (onConfirm(value) === false) return;
    } catch (err) {
      console.error('[g5-gurumi] input modal confirm failed', err);
      return;
    }
    close();
  }

  backdrop.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
  cancel.addEventListener('click', close);
  ok.addEventListener('click', submit);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      submit(e);
    }
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
    }
  });

  setTimeout(() => {
    input.focus();
    input.select();
  }, 30);

  return { close };
}
